import styled from 'styled-components'

export const Caption = styled.div`
  width: 40px;
  height: 11px;
  background-color: ${({ color }) => color ? color : 'green'};
`
